import * as action_types from '../actions/action_types';

const initialState = {
  isShowing: false,
  type: '',
};

export const HelpboxReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case action_types.SHOW_HELPBOX:
      return {
        ...state,
        isShowing: action.data.isShowing,
        type: action.data.type,
      };
    case action_types.HIDE_HELPBOX:
      return {
        ...state,
        isShowing: action.data.isShowing,
      };
    default:
      return state;
  }
};
